import { render, staticRenderFns } from "./widget-checkbox.vue?vue&type=template&id=7fbc7f2e&scoped=true"
import script from "./widget-checkbox.vue?vue&type=script&lang=js"
export * from "./widget-checkbox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fbc7f2e",
  null
  
)

export default component.exports